import { SxProps, Theme } from '@mui/system';

const styles = {
  autocomplete: {
    ml: 1,
    '& .MuiFormControl-root': {
      backgroundColor: 'secondary.main',
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
